var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg111(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3689 22.54H14.6378C13.0022 22.54 11.6763 23.866 11.6763 25.5016V35.8671C11.6763 37.5028 13.0022 38.8287 14.6378 38.8287H35.3689C37.0045 38.8287 38.3304 37.5028 38.3304 35.8671V25.5016C38.3304 23.866 37.0045 22.54 35.3689 22.54Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5967 22.5377V16.6145C17.5948 14.7784 18.2753 13.0071 19.506 11.6445C20.7366 10.2819 22.4297 9.42515 24.2565 9.24063C26.0833 9.0561 27.9135 9.55694 29.3919 10.6459C30.8702 11.7349 31.8911 13.3343 32.2565 15.1337V22.5377",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3684 22.5391H14.6374C13.0017 22.5391 11.6758 23.865 11.6758 25.5006V35.8661C11.6758 37.5018 13.0017 38.8277 14.6374 38.8277H35.3684C37.004 38.8277 38.3299 37.5018 38.3299 35.8661V25.5006C38.3299 23.865 37.004 22.5391 35.3684 22.5391Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5962 22.5367V16.6135C17.5943 14.7774 18.2748 13.0061 19.5055 11.6435C20.7362 10.2809 22.4292 9.42418 24.256 9.23965C26.0829 9.05512 27.9131 9.55597 29.3914 10.645C30.8697 11.7339 31.8906 13.3334 32.256 15.1328V22.5367",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg111);
export default __webpack_public_path__ + "static/media/11.1.de64d4283459cccca460ad6d60599617.svg";
export { ForwardRef as ReactComponent };